"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _dictionary = _interopRequireDefault(require("./dictionary"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.linkProps, _utils.viewProps]);
const selectOuterStyles = _ref => {
  let {
    borderColor,
    borderWidth,
    borderGap,
    borderRadius,
    padding
  } = _ref;
  return {
    outline: 'none',
    borderColor,
    borderWidth,
    borderGap,
    borderRadius,
    padding
  };
};
const DownloadApp = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    copy = 'en',
    dictionary = _dictionary.default,
    type = 'ios',
    href,
    onPress,
    tokens = {},
    variant = {},
    ...props
  } = _ref2;
  const getCopy = (0, _utils.useCopy)({
    dictionary,
    copy
  });
  const {
    hrefAttrs,
    rest
  } = _utils.hrefAttrsProp.bundle(props);
  const selectedProps = selectProps({
    accessibilityRole: href ? 'link' : 'button',
    href,
    onPress: _utils.linkProps.handleHref({
      href,
      onPress
    }),
    hrefAttrs,
    ...rest
  });
  const getDownloadAppTokens = (0, _ThemeProvider.useThemeTokensCallback)('DownloadApp', tokens, variant);
  const resolveDownloadAppTokens = pressableState => {
    const themeTokens = (0, _utils.resolvePressableTokens)(getDownloadAppTokens, pressableState, {});
    return selectOuterStyles(themeTokens);
  };
  const {
    androidENIcon,
    androidFRIcon,
    iosENIcon,
    iosFRIcon
  } = getDownloadAppTokens();
  const imageResources = {
    en: {
      android: androidENIcon,
      ios: iosENIcon
    },
    fr: {
      android: androidFRIcon,
      ios: iosFRIcon
    }
  };
  const IconComponent = imageResources[copy][type];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    ref: ref,
    style: pressState => [resolveDownloadAppTokens(pressState), staticStyles.row],
    ...selectedProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
      style: staticImageSizes[type][copy],
      alt: type === 'ios' ? getCopy('altTextIos') : getCopy('altTextAndroid')
    })
  });
});
DownloadApp.displayName = 'DownloadApp';
const dictionaryContentShape = _propTypes.default.shape({
  altTextAndroid: _propTypes.default.string.isRequired,
  altTextIos: _propTypes.default.string.isRequired
});
DownloadApp.propTypes = {
  ...selectedSystemPropTypes,
  copy: _utils.copyPropTypes,
  /**
   * Override the default dictionary, by passing the complete dictionary object for `en` and `fr`
   */
  dictionary: _propTypes.default.shape({
    en: dictionaryContentShape,
    fr: dictionaryContentShape
  }),
  /**
   * Select the type of image to show.
   */
  type: _propTypes.default.oneOf(['android', 'ios']),
  /**
   * It's a simple link that opens the Download Button instead of the onPress function.
   */
  href: _propTypes.default.string,
  /**
   * Function called when the button is pressed. Required unless the button has a href.
   */
  onPress: _propTypes.default.func,
  /**
   * DownloadApp tokens.
   */
  tokens: (0, _utils.getTokensPropType)('DownloadApp'),
  /**
   * DownloadApp variant.
   */
  variant: _utils.variantProp.propType
};
const staticStyles = _StyleSheet.default.create({
  row: {
    ..._Platform.default.select({
      web: {
        display: 'inline-flex',
        width: 'fit-content'
      },
      default: {
        alignSelf: 'flex-start'
      }
    })
  }
});
const staticImageSizes = {
  android: {
    en: {
      width: 162,
      height: 48
    },
    fr: {
      width: 162,
      height: 48
    }
  },
  ios: {
    en: {
      width: 144,
      height: 48
    },
    fr: {
      width: 152,
      height: 48
    }
  }
};
var _default = exports.default = DownloadApp;